export default function mask() {
  window.JqueryMaskPlugin(document).ready(function() {
    window.JqueryMaskPlugin('.phone').mask('(00) 00000-0000')
    window.JqueryMaskPlugin('.cep').mask('00000-000')
    window.JqueryMaskPlugin('.cnpj').mask('00.000.000/0000-00')
    window.JqueryMaskPlugin('.date').mask('00/00/0000')
    window.JqueryMaskPlugin('.enrollment').mask('000.000.000.000', {
      translation: {
        '0': {
          pattern: /[0-9]/,
        },
      },
      reverse: true,
    })
  })
}
